// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 9.53158L12 1.19824L2 9.53158V22H7.5V13.5H16.5V22H22V9.53158Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5 22H9.5V15.5H14.5V22Z"}}]};

const HomeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'home-filled',
    ref,
    icon: element,
  },
));

HomeFilledIcon.displayName = 'HomeFilledIcon';

export default HomeFilledIcon;
